import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import eventTypes from 'theme/eventTypes';
import { useEvent } from 'context/events/Event';
import { useBackButtonCollapse } from 'context/general/BackButtonCollapse';
// import useAuth from 'hooks/useAuth';
import { Calendar, Clock, DollarSign, Hash, Heart, MapPin, Share, Share2, Tag, X } from 'lucide-react';
import Modal from 'components/_UI/Modal';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCollapse } from 'context/general/Collapse';
import { useInvisibleButton } from 'context/general/InvisibleButton';
import DynamicProfileImage from 'components/commons/DynamicProfileImage';
import DescriptionWithHTML from './DescriptionWithHTML';
import Text from 'components/_UI/Text';
import LinkPage from 'components/_UI/LinkPage';
import types from 'helpers/system/types';
import fonts from 'theme/fonts';
import Icon from 'components/_UI/Icon';
import InfoTooltip from 'components/_UI/InfoTooltip';
import Button from 'components/_UI/Button';
import Loader from 'components/_UI/Loader';
import eventApi from 'api/requests/events';
import date from 'helpers/date';
import { useAuth } from 'context/auth/Auth';
import useFavorite from 'hooks/useFavorite';
import useShare from 'hooks/useShare';

export default function EventDetailV2({ data, fromHome = false, onClose }) {
    const textIa = 'kaue.ia'

    // const navigate = useNavigate();
    // const location = useLocation();
    // const { collapse, setCollapse } = useCollapse();
    // const { backButtonCollapse, setBackButtonCollapse } = useBackButtonCollapse();

    // const [fullCronogramModal, setFullCronogramModal] = useState(false);
    // const [goToLoginModal, setGoToLoginModal] = useState(false);
    const [hasTickets, setHastickets] = useState(null);
    const [hasProducts, setHasProducts] = useState(null);
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [ticketUrl, setTicketUrl] = useState(false);
    const { setInvisibleButton } = useInvisibleButton();
    const { isFavorited, toggleFavorite } = useFavorite(data?.slug, data?.is_favorited);
    const { share } = useShare();
    const [linkCopied, setLinkCopied] = useState(false);
    const { isAuth } = useAuth();

    function handleFavorite() {
        if (!isAuth && onClose) {
            onClose();
        }
        toggleFavorite();
    }

    useEffect(() => {
        getEvent(data?.slug);
    }, []);

    async function getEvent(slug) {
        setLoading(true);
        try {
            const { data: eventData } = await eventApi.getBySlug(slug, fromHome ? { fromHome: true } : {});
            setContent(eventData?.data);
            setTicketUrl(`${import.meta.env.VITE_CLIENT_URL}/evento/${data?.slug}`);
            setHastickets(eventData?.data?.products?.filter(el => el.type == 'ticket'));
            setHasProducts(eventData?.data?.products?.filter(el => el.type == 'product'));
        } catch (error) {
            console.error('Error fetching event:', error);
        } finally {
            setLoading(false);
        }
    }

    async function handleShare() {
        const shareUrl = content?.link_ticket || ticketUrl || `${window.location.origin}/evento/${data?.slug}`;
        const result = await share({
            title: content?.name,
            url: shareUrl,
        });

        if (result?.method === 'clipboard' && result?.success) {
            setLinkCopied(true);
            setTimeout(() => setLinkCopied(false), 2500);
        }
    }

    return (
        <Container>
            {
                loading ? (
                    <FullyCentered height='250px'>
                        <Loader />
                    </FullyCentered>
                ) : (
                    content?.name && (
                        <>
                            <StyledBackgroundContainer>
                                {onClose && (
                                    <MobileCloseBtn onClick={onClose}>
                                        <X size={18} />
                                    </MobileCloseBtn>
                                )}
                                <StyledBackground
                                    src={content?.images?.[0] || '/assets/images/placeholder-events.png'}
                                    onError={(e) => { e.target.onerror = null; e.target.src = '/assets/images/placeholder-events.png'; }}
                                />

                                {/* 👇 Overlay com título e data/hora */}
                                <OverlayContent>
                                    <Text name='subtitle' color={colors.neutralLight} paddingBottom={0}>
                                        {content.name}
                                    </Text>

                                    <Row marginTop='6px'>
                                        <Row width='auto'>
                                            <Calendar size={14} color={colors.neutralLight} />
                                            <Text
                                                marginLeft={'4px'}
                                                color={colors.neutralLight}
                                                paddingBottom={0}
                                            >
                                                {date.format(content?.dates[0]?.date,)}
                                            </Text>
                                        </Row>

                                        <Row marginLeft='10px'>
                                            <Clock size={14} color={colors.neutralLight} />
                                            <Text
                                                marginLeft={'4px'}
                                                color={colors.neutralLight}
                                                paddingBottom={0}
                                            >
                                                {date.formatTime(content?.dates[0]?.start)}
                                            </Text>
                                        </Row>
                                    </Row>
                                </OverlayContent>
                            </StyledBackgroundContainer>

                            <ContentContainer>
                                <TagsRow marginTop='-6px'>
                                    {/* <FullyCentered width='auto'>
                        <DollarSign
                            color={content?.classification?.name == eventTypes.free.slug ? eventTypes.free.color : eventTypes.paid.color}
                        />
                        <Text
                            paddingBottom={0}
                            type='bold'
                            color={content?.classification?.name == eventTypes.free.slug ? eventTypes.free.color : eventTypes.paid.color}
                        >
                            Evento {types.getBySlug(content?.classification?.name).label}
                        </Text>
                    </FullyCentered> */}
                                    <TagItem type={content?.classification?.name == eventTypes.free.slug ? eventTypes.free.slug : eventTypes.paid.slug}>
                                        <Text
                                            color={colors.neutralLight}
                                            type='bold'
                                            name='small'
                                        >
                                            Evento {types.getBySlug(content?.classification?.name)?.label}
                                        </Text>
                                    </TagItem>

                                    {
                                        content?.adulthood && (
                                            <TagItem adulthood>
                                                <Text
                                                    color={colors.neutralLight}
                                                    type='bold'
                                                    name='small'
                                                > +18
                                                </Text>
                                            </TagItem>
                                        )
                                    }

                                    {content?.tags?.map(el => (

                                        <TagItem>
                                            <Text
                                                color={colors.neutralLight}
                                                type='bold'
                                                name='small'
                                            >
                                                {el.name}
                                            </Text>
                                        </TagItem>

                                    ))}
                                </TagsRow>

                                {/* <CategoriesInfos>
                    <FullyCentered width='auto'>
                        <Tag color={colors.secondaryPurple} />
                    </FullyCentered>


                    {content?.tags?.map(el => (
                        <Text marginLeft={'6px'} >
                            #{el.name}
                        </Text>
                    ))}
                </CategoriesInfos> */}

                                {
                                    !content?.hide_address && (
                                        <ContentInfoRow address>
                                            <MapPin color={colors.secondaryPurple} size={20} style={{ marginRight: 10 }} />
                                            {
                                                content?.address ? (
                                                    <ContentLinkAddress>
                                                        <LinkPage isWrapper to={content.link_map}>
                                                            <Text color={colors.primaryDark} decoration='underline' paddingBottom={'0px'}>
                                                                {content?.address?.street?.name && `${content?.address?.street?.name},`} {content?.address?.street?.district && `Bairro ${content?.address?.street?.district}`}
                                                                {content.address.number && `, nº ${content.address.number}`}
                                                                {content.address.complement && ` - ${content.address.complement}`}
                                                            </Text>
                                                        </LinkPage>
                                                    </ContentLinkAddress>
                                                ) : (
                                                    <Text color={colors.secondaryPurple} paddingBottom={'0px'}>
                                                        Local a definir
                                                    </Text>
                                                )
                                            }

                                        </ContentInfoRow>
                                    )
                                }

                                {
                                    content?.origin === textIa && (
                                        <Row verticalCenter marginBottom='15px'>
                                            <StyledIa>
                                                <Icon name='smartToy' color={colors.secondaryPurple} />
                                            </StyledIa>

                                            <Text paddingBottom={'0'} color={colors.nightDark} marginLeft={'10px'}>Evento mapeado através de IA</Text>

                                            <InfoTooltip
                                                bgColor={colors.night}
                                                text=<>O Whizr usa inteligência artificial para o mapeamento de eventos que não são cadastrados através de parceiros oficiais.
                                                    <br></br>
                                                    Recomendamos checar as informações no local oficial do evento.</>
                                                type='info'
                                            />
                                        </Row>
                                    )}

                                {
                                    content?.establishment?.name && (
                                        <Row width='100%'>
                                            <LinkPage target={'_blank'} to={`/estabelecimentos?estabelecimento=${content?.establishment?.slug}`}>
                                                <ContentOrganizer>
                                                    <DynamicProfileImage
                                                        size='24px'
                                                        img={content?.establishment?.profile_image_id?.thumb}
                                                        word={content?.establishment?.name}
                                                        textSize='normal'
                                                    />
                                                    <Text color={colors.nightDark} paddingBottom={'0'} marginLeft={'10px'} marginRight={'5px'}>Organizado por</Text>
                                                    <Text color={colors.nightDark} type='bold' paddingBottom={'0px'}>{content?.establishment?.name}</Text>
                                                </ContentOrganizer>
                                            </LinkPage>
                                        </Row>
                                    )
                                }

                                <SpecialDivider />

                            </ContentContainer>

                            <Description>
                                <Text marginTop='10px' color={colors.secondaryPurple} name='highlight'>
                                    Sobre o evento:
                                </Text>
                                {
                                    content?.description_with_html
                                        ? (
                                            <DescriptionWithHtmlContainer>
                                                <DescriptionWithHTML data={content?.description_with_html} />
                                            </DescriptionWithHtmlContainer>
                                        ) : (
                                            <Text
                                                color={colors.nightDark}
                                                marginTop='2px'
                                                marginBottom='16px'
                                            >
                                                {content.description}
                                            </Text>
                                        )
                                }
                            </Description>

                            {
                                (!!hasTickets.length || !!hasProducts.length) && (
                                    <Footer>
                                        <Row>
                                            <SpecialButton
                                                category='squiredBorded'
                                                variant='featured'
                                                href={ticketUrl}
                                                target='_blank'
                                            >
                                                <Column width='18px' height='18px'>
                                                    <Icon name='diagonal-ticket' color={colors.neutralLight} />
                                                </Column>
                                                <Text name='highlight' color={colors.neutralLight} paddingBottom={0} marginLeft={'6px'}>
                                                    Garanta seu ingresso
                                                </Text>
                                            </SpecialButton>
                                            <SpecialButton onClick={handleFavorite}>
                                                <Heart
                                                    color={colors.secondaryPurple}
                                                    fill={isFavorited ? colors.secondaryPurple : 'none'}
                                                    size={18}
                                                />
                                            </SpecialButton>

                                            <SpecialButton onClick={handleShare}>
                                                {linkCopied
                                                    ? <Text name='small' paddingBottom={0} color={colors.secondaryPurple}>Copiado!</Text>
                                                    : <Share2 color={colors.secondaryPurple} size={18} />
                                                }
                                            </SpecialButton>
                                        </Row>
                                    </Footer>
                                )
                            }

                            {
                                !!content?.link_ticket && (
                                    <Footer>
                                        <Row>
                                            <SpecialButton
                                                category='squiredBorded'
                                                variant='featured'
                                                href={content?.link_ticket}
                                                target='_blank'
                                            >
                                                <Column width='18px' height='18px'>
                                                    <Icon name='diagonal-ticket' color={colors.neutralLight} />
                                                </Column>
                                                <Text name='highlight' color={colors.neutralLight} paddingBottom={0} marginLeft={'6px'}>
                                                    Garanta seu ingresso
                                                </Text>
                                            </SpecialButton>
                                            <SpecialButton onClick={handleFavorite}>
                                                <Heart
                                                    color={colors.secondaryPurple}
                                                    fill={isFavorited ? colors.secondaryPurple : 'none'}
                                                    size={18}
                                                />
                                            </SpecialButton>

                                            <SpecialButton onClick={handleShare}>
                                                {linkCopied
                                                    ? <Text name='small' paddingBottom={0} color={colors.secondaryPurple}>Copiado!</Text>
                                                    : <Share2 color={colors.secondaryPurple} size={18} />
                                                }
                                            </SpecialButton>
                                        </Row>
                                    </Footer>
                                )
                            }
                        </>
                    )
                )
            }
        </Container>
    );
}

const MobileCloseBtn = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(4px);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    flex-shrink: 0;
`;

const Container = styled(Column)`
    position: relative;
`;

const StyledBackgroundContainer = styled(FullyCentered)`
    width: 100%;
    height: auto;
    position: relative;
    background: ${colors.neutralDark};
    overflow: hidden;
`;

const StyledBackground = styled.img`
    width: 100%;
    height: 200px;
    object-fit: cover;

    @media screen and (min-width: ${breakpoints.md}) {
        height: 290px;
    }
`;

const OverlayContent = styled(Column)`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 12px;
    background: rgba(0, 0, 0, 0.7); /* fundo preto semi-transparente */
    backdrop-filter: blur(6px); /* blur */
    -webkit-backdrop-filter: blur(6px); /* Safari */

    @media screen and (min-width: ${breakpoints.md}) {
        padding: 16px 20px;
    }
`;

const ContentContainer = styled(Column)`
    padding: 14px 14px 0 14px;

    @media screen and (min-width: ${breakpoints.md}) {
        padding: 20px 20px 0 20px;
    }
`;


const ContentInfoRow = styled(Row)`
    margin-bottom: 10px;
    align-items: flex-start;
    text-align: left;
    margin-top: 14px;

    ${({ address }) => address && `
        align-items: center;
    `}
    
    ${({ single }) => single && `
        align-items: center;

        & > p {
            padding-bottom: 0 !important;
        }
    `}

    &:nth-child(3){
        margin-bottom: 0;
    }

    & > p {
        padding: 0;
        margin: 0;
    }

    & > a > p{
        padding-bottom: 0 !important;
    }
`;

const ContentLinkAddress = styled.div`
    width: auto;
`;

const CategoriesInfos = styled(Row)`
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 16px;

    & > p {
        padding-bottom: 0;
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        margin-bottom: 10px;    
        justify-content: flex-start;
    }
    
`;

const EventType = styled.div`
    color: ${colors.neutralLight};
    border-radius: 30px;
    padding: 4px 10px;
    font-size: ${fonts.sizes.small};
    text-transform: capitalize;
    margin-top: 8px;

    ${({ type }) => type === eventTypes.free.slug && `
        background: ${eventTypes.free.color};
    `}

    ${({ type }) => type === eventTypes.paid.slug && `
        background: ${eventTypes.paid.color};
    `}
`;


const TagsRow = styled(Row)`
    flex-wrap: wrap;
    align-items: flex-start;
`;

const TagItem = styled(FullyCentered)`
    padding: 4px 8px;
    border-radius: 30px;
    background: ${colors.occasionalOrange};
    width: auto;
    margin-left: 6px;
    margin-top: 8px;

    ${({ adulthood }) => adulthood && `
        background: ${colors.nightDark};
        // margin-top: 0;
        // margin-left: 6px;
    `};
    
    ${({ type }) => type === eventTypes.free.slug && `
        margin-left: 0px;
        background: ${eventTypes.free.color};
    `};

    ${({ type }) => type === eventTypes.paid.slug && `
        margin-left: 0px;
        background: ${eventTypes.paid.color};
    `};

    & > p {
        padding-bottom: 0 !important;
        text-transform: capitalize !important;
    }
`;

const Description = styled(Column)`
    padding: 4px 14px 30px 14px;
    align-items: flex-start;
    text-align: left;

    @media screen and (min-width: ${breakpoints.md}) {
        padding: 4px 22px 30px 22px;
    }
`;

const DescriptionWithHtmlContainer = styled(Column)`
    /* @media screen and (min-width: ${breakpoints.sm}) {
        padding: 0 26px;
    } */
`;

const StyledIa = styled.div`
    width: 22px;
    height: 22px;
`;

const ContentOrganizer = styled(Row)`
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    /* margin-bottom: 15px; */
    text-align: left;

    transition: all ease-in-out .25s;
    &:hover {
        transform: scale(1.01)
    }
`;

const Footer = styled(Row)`
    position: sticky;
    bottom: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    padding: 10px 8px;
    border-top: 1px solid ${colors.nightLight};
    z-index: 10;

    @media screen and (max-width: 899px) {
        padding: 12px 10px;
        padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 16px);
        border-radius: 0 0 16px 16px;
    }
`;

const SpecialButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    min-height: 44px;
    min-width: 44px;
    border-radius: 12px;
    margin-left: 10px;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    cursor: pointer;

    &:first-child {
        flex: 1;
        margin-left: 0;
        background: ${colors.secondaryPurple};
        border: 1px solid ${colors.secondaryPurple};

        & > h3 {
            font-weight: ${fonts.weight.regular} !important;
            color: ${colors.neutralLight};
        }
    }

    &:not(:first-child) {
        background: rgba(255, 255, 255, 0.6); /* fundo neutro para os outros botões */
        border: 1px solid ${colors.secondaryPurple};
    }

    &:hover {
        transform: scale(1.015);
        opacity: 0.95;
    }
`;

const SpecialDivider = styled.div`
    width: 100%;
    height: 1px;
    background: ${colors.nightLight};
    margin: 5px 0 5px 0;
`;